module.exports = __webpack_public_path__ + "img/activity_head_bg.d93239a5.png";